var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "board-level-automations-container" } },
    [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("automation-share-selection", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.shareSelection,
                expression: "!shareSelection",
              },
            ],
          }),
          _vm._v(" "),
          _c("automation-editor", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shareSelection,
                expression: "shareSelection",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("automation-saved", { attrs: { level: "board" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "deleteModal",
          staticClass: "modal",
          attrs: { tabindex: "-1", role: "dialog" },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("automations.boardLevel.deleteAutomation")
                        ) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "automations.boardLevel.deleteAutomationConfirmation"
                          )
                        ) +
                        ":\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.deleting
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row mt-3 pl-2 no-gutters d-flex align-items-center",
                          attrs: { id: "new-trigger" },
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.when")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("automation-dropdown", {
                            attrs: {
                              value: _vm.automationToDelete.trigger,
                              items: _vm.triggers,
                              placeholder: _vm.$t("automations.selectTrigger"),
                              "read-only": "",
                              triggers: "",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.emptyAutomationToDeleteTrigger
                            ? _c("trigger-arguments", {
                                attrs: {
                                  value:
                                    _vm.automationToDelete.triggerArguments,
                                  trigger: _vm.automationToDelete.trigger,
                                  editing: _vm.editing,
                                  "read-only": "",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.shouldShowActionSelect
                            ? [
                                _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "automations.boardLevel.performTheFollowingTask"
                                        )
                                      ) +
                                      ":\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("automation-dropdown", {
                                  attrs: {
                                    value: _vm.automationToDelete.action,
                                    items: _vm.actions,
                                    placeholder: _vm.$t(
                                      "automations.selectAction"
                                    ),
                                    "read-only": "",
                                  },
                                }),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.emptyAutomationToDeleteAction
                            ? _c("action-arguments", {
                                key: _vm.getKey(_vm.automationToDelete.action),
                                attrs: {
                                  value: _vm.automationToDelete.actionArguments,
                                  action: _vm.automationToDelete.action,
                                  trigger: _vm.triggers,
                                  "read-only": "",
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-white",
                        attrs: { type: "button" },
                        on: { click: _vm.cancelDelete },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.words.no")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "simple-button",
                      {
                        attrs: {
                          type: "danger",
                          loading: _vm.saving,
                          "loading-succeeded": _vm.savingStatus,
                        },
                        on: { click: _vm.acceptDelete },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.words.delete")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }